import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="blurb-editor"
export default class extends Controller {
  static targets = ["textarea", "timer", "form", "duplicateBlurbFilter"];

  connect() {
    // Initialize the timer when controller is connected
    if (this.hasTextareaTarget) {
      this.updateTimer();
      this.textareaTarget.addEventListener("keydown", this.handleKeydown.bind(this));
    }
  }

  disconnect() {
    // Clean up to avoid memory leaks when the frame is replaced
    if (this.hasTextareaTarget) {
      this.textareaTarget.removeEventListener("keydown", this.handleKeydown.bind(this));
    }
  }

  handleKeydown(event) {
    if (String.fromCharCode(event.keyCode) !== " ") {
      this.updateTimer();
    }
  }

  updateTimer() {
    const currentText = this.textareaTarget.value.replace(/\s+/g, "");
    const timing = Math.floor(currentText.length / 12);
    this.timerTarget.textContent = this.formatTime(timing);
  }

  formatTime(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  async submit(event) {
    event.preventDefault();

    const formData = new FormData(event.target);

    try {
      const response = await fetch(event.target.action, {
        method: "POST",
        headers: {
          "Accept": "application/json"
        },
        body: formData
      });
      const data = await response.json();
      if (data.status === "ok") {
        window.location = data.redirect_url;
      } else {
        if (data.status === "duplicate") {
          this.duplicateBlurbFilterTarget.innerHTML = data.html;
        }
      }
    } catch(error) {
      console.error("Error submitting form:", error);
    }
  }
}
